import { Picker } from "emoji-mart";
import "emoji-mart/css/emoji-mart.css";
import React from "react";
import { COLOR_PRIMARY } from "../../constants/theme";

interface Props {
  onAdding: (arg0: any) => void;
}

/** Altura acotada para que el panel no desborde el viewport; el scroll queda en el contenedor padre. */
const PICKER_MAX_HEIGHT = 280;

export const EmojiForm = ({ onAdding }: Props) => {
  return (
    <div className="emoji-form-root">
      <Picker
        style={{
          border: 0,
          boxShadow: "none",
          width: "100%",
          height: PICKER_MAX_HEIGHT,
          maxHeight: PICKER_MAX_HEIGHT,
          padding: "4px",
        }}
        color={COLOR_PRIMARY}
        showPreview={true}
        sheetSize={32}
        showSkinTones={true}
        onSelect={onAdding}
      />
    </div>
  );
};
